import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styled from 'styled-components'
import Card from '../../components/Card'
import patient from '../../stores/patient'
import Text from '../../components/Text'

const Wrap = styled.div`
	display: flex;
	align-items: center;
`

const TimeImage = styled.img`
	flex-shrink: 0;
	margin: 1rem;
	width: 4rem;
`

const Location = styled.div`
	margin-right: 1rem;
`

const Description = styled.div`
	border-left: 1px solid #ccc;
	flex: 1;
	padding: 1rem;
	align-self: stretch;
`

@observer
export default class PlanCard extends Component {
  render() {
    const { index } = this.props

    return (
      <Card>
		  {/* <Card.Pad> */}
			<Wrap>
				<TimeImage src={`/images/time/${patient.fields.plans[index].timePeriod === 'AM' ? 'DAY' : 'NIGHT'}.png`} />
				<Location>
					<p style={{marginBottom: '0.75rem'}}>{patient.fields.plans[index].time} {patient.fields.plans[index].timePeriod}</p>
					<p><Text str={`choices.location.${patient.fields.plans[index].location}`} /></p>
				</Location>
				<Description>
					{patient.fields.plans[index].routine}
				</Description>
			</Wrap>
		  {/* </Card.Pad> */}
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/PhoneSession/PlanCard.js